import { useDataTable } from '@/hooks/use-data-table'
import { useCustomersList } from '../hooks/use-customers-list'
import { useCustomerColumns } from './columns'
import { CustomersHeader } from './customers-header'
import { CustomersTable } from './customers-table'
import { useCustomerParams } from './use-customer-params'
import { PageLayoutContainer } from '@/components/page-layout'

const CustomersPage = () => {
	const { q } = useCustomerParams()
	const { customerList, handleDelete, handleEnrich, handleCancelEnrichment, handleClearEnrichment } = useCustomersList()

	const columns = useCustomerColumns()
	const { table } = useDataTable({
		data: customerList,
		columns,
		getRowId: row => row.id,
		meta: {
			deleteCustomer: handleDelete,
			enrichCustomer: handleEnrich,
			cancelEnrichment: handleCancelEnrichment,
			clearEnrichment: handleClearEnrichment,
		},
	})

	return (
		<PageLayoutContainer>
			<CustomersHeader table={table} />
			<CustomersTable data={customerList} hasFilters={Boolean(q)} table={table} />
		</PageLayoutContainer>
	)
}

export { CustomersPage }
